import type { DetailCardPresentation } from '../types/presentation.types';

const PROFILE_TITLE_RE = /\bmy\s+profile\b|^profile$/i;
const PROFILE_ENTITY_RE = /^(profile|member|user|me)$/i;
const PROFILE_ASK_RE =
  /\b(my\s+profile|who\s+am\s+i|about\s+me|my\s+account|my\s+user)\b/i;

const PROFILE_FIELD_KEYS = new Set([
  'is_confirmed',
  'last_login',
  'last_login_at',
  'type',
  'member_type',
]);

/** True when a detail_card looks like an unsolicited member/profile dump. */
export function isProfileDetailCard(block: DetailCardPresentation): boolean {
  if (PROFILE_TITLE_RE.test(block.title.trim())) return true;
  if (PROFILE_ENTITY_RE.test(block.entity.trim())) return true;
  const keys = block.fields.map((f) => f.key.toLowerCase());
  const hits = keys.filter((k) => PROFILE_FIELD_KEYS.has(k)).length;
  return hits >= 2 && keys.some((k) => k === 'id' || k.endsWith('_id'));
}

/** True when the user's turn asked to see their own profile. */
export function userAskedForProfile(userText: string | undefined): boolean {
  if (!userText) return false;
  return PROFILE_ASK_RE.test(userText);
}

/**
 * Profile cards only render when the user asked for their profile.
 * Every other detail_card passes through.
 */
export function shouldShowDetailCard(
  block: DetailCardPresentation,
  userText: string | undefined
): boolean {
  if (!isProfileDetailCard(block)) return true;
  return userAskedForProfile(userText);
}
